import gql from 'graphql-tag';

export default gql`
  fragment WaveTab on Wave {
    id
    name
    releasedAt
    repSample
  }
`;



// WEBPACK FOOTER //
// ./src/queries/fragmentWaveTab.js